export default "__VITE_ASSET__DK8FWmz___"